<template>
  <nav class="navbar app-navbar" aria-label="Navegación principal">
    <div class="navbar__left">
      <button type="button" class="navbar__brand" @click="goHome" aria-label="Ir al inicio">
        <img alt="Quick Pay" src="../assets/logo_quick_pay_2022.png" />
      </button>
    </div>

    <div class="navbar__center" id="main-header">
      <ul class="nav-menu desktop-menu" id="menu">
        <li v-for="menu of list" :key="menu.id">
          <button
            type="button"
            class="nav-link"
            :class="{ 'is-active': isActive === menu.id }"
            :title="menu.name"
            @click="changePage(menu.path)"
          >
            <i :class="menuIcon(menu)" aria-hidden="true"></i>
            <span>{{ menu.name }}</span>
          </button>
        </li>
      </ul>

      <button
        type="button"
        class="hamburger"
        :class="{ 'is-open': isMenuOpen }"
        :aria-expanded="isMenuOpen ? 'true' : 'false'"
        aria-controls="mobile-drawer"
        :aria-label="isMenuOpen ? 'Cerrar menú' : 'Abrir menú'"
        @click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <div id="navbar-right" class="navbar__right">
      <div class="profile">
        <div class="profile__user" :title="usuario">
          <div class="profile__avatar" aria-hidden="true">{{ userInitials }}</div>
          <div class="profile__detail">
            <p class="profile__name">{{ usuario }}</p>
            <span class="profile__date">{{ fecha }}</span>
          </div>
        </div>
        <button
          type="button"
          class="nav-icon-btn"
          :class="{ 'is-active': isConfigPage }"
          title="Configuración"
          aria-label="Configuración"
          @click="goConfiguracion"
        >
          <i class="fa-solid fa-gear" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="nav-icon-btn nav-icon-btn--logout"
          title="Cerrar sesión"
          aria-label="Cerrar sesión"
          @click="handleClick"
        >
          <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <Teleport to="body">
      <div
        v-if="isMenuOpen"
        class="nav-overlay"
        @click="closeMenu"
      ></div>
      <aside
        id="mobile-drawer"
        class="mobile-drawer"
        :class="{ 'is-open': isMenuOpen }"
        role="dialog"
        aria-modal="true"
        aria-label="Menú"
        :aria-hidden="isMenuOpen ? 'false' : 'true'"
      >
        <div class="mobile-drawer__head">
          <div class="profile__user">
            <div class="profile__avatar" aria-hidden="true">{{ userInitials }}</div>
            <div class="profile__detail">
              <p class="profile__name">{{ usuario }}</p>
              <span class="profile__date">{{ fecha }}</span>
            </div>
          </div>
          <button
            type="button"
            class="nav-icon-btn"
            aria-label="Cerrar menú"
            @click="closeMenu"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>

        <ul class="mobile-drawer__nav">
          <li v-for="menu of list" :key="'m-' + menu.id">
            <button
              type="button"
              class="nav-link nav-link--block"
              :class="{ 'is-active': isActive === menu.id }"
              @click="changePage(menu.path)"
            >
              <i :class="menuIcon(menu)" aria-hidden="true"></i>
              <span>{{ menu.name }}</span>
            </button>
          </li>
        </ul>

        <div class="mobile-drawer__footer">
          <button type="button" class="nav-link nav-link--block" :class="{ 'is-active': isConfigPage }" @click="goConfiguracion">
            <i class="fa-solid fa-gear" aria-hidden="true"></i>
            <span>Configuración</span>
          </button>
          <button type="button" class="nav-link nav-link--block nav-link--danger" @click="handleClick">
            <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
            <span>Salir</span>
          </button>
        </div>
      </aside>
    </Teleport>
  </nav>
</template>

<script>
export default {
  name: "navbar",
  props: {
    isActive: Number,
  },
  data() {
    return {
      fecha: "",
      usuario: "",
      list: [],
      isMenuOpen: false,
    };
  },
  computed: {
    isConfigPage() {
      return this.$route.path === "/configuracion";
    },
    userInitials() {
      if (!this.usuario) return "?";
      const parts = this.usuario.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return "?";
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    },
  },
  watch: {
    $route() {
      this.closeMenu();
    },
    isMenuOpen(open) {
      document.body.style.overflow = open ? "hidden" : "";
    },
  },
  methods: {
    menuIcon(menu) {
      const n = ((menu && menu.name) || "").toLowerCase();
      if (n.includes("comercial")) return "fas fa-store";
      if (n.includes("operativa")) return "fas fa-sync-alt";
      if (n.includes("contable")) return "fas fa-calculator";
      if (n.includes("incidencia")) return "fas fa-exclamation-circle";
      if (n.includes("indicador")) return "fas fa-chart-line";
      if (n.includes("mesa")) return "fas fa-utensils";
      if (n.includes("buz") || n.includes("sugerenc")) return "fas fa-inbox";
      if (n.includes("cliente")) return "fas fa-building";
      if (n.includes("usuario")) return "fas fa-users";
      if (n.includes("concili")) return "fas fa-balance-scale";
      return "fas fa-th-large";
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    onKeydown(e) {
      if (e.key === "Escape") this.closeMenu();
    },
    onResize() {
      if (window.innerWidth > 1100) this.closeMenu();
    },
    goHome() {
      const first = this.list && this.list[0];
      this.changePage((first && first.path) || "/");
    },
    goConfiguracion() {
      this.closeMenu();
      if (this.$route.path !== "/configuracion") {
        this.$router.push("/configuracion");
      }
    },
    basicInfo() {
      this.usuario = localStorage.getItem("usuario") || "";
      let list = JSON.parse(localStorage.getItem("getListOfMenu") || "[]") || [];
      if (localStorage.getItem("role") === "cliente") {
        const mesasItem = list.find((item) => item.path === "/mesas" || item.id === 6);
        if (!mesasItem) {
          list = [
            ...list,
            { id: 6, path: "/mesas", name: "Servicio de mesa", class: "" },
          ];
          localStorage.setItem("getListOfMenu", JSON.stringify(list));
        } else if (mesasItem.name === "Mesas") {
          mesasItem.name = "Servicio de mesa";
          localStorage.setItem("getListOfMenu", JSON.stringify(list));
        }
      }
      this.list = list;
      this.getDate();
    },
    getDate() {
      const dias = [
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
        "Domingo",
      ];
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      const date = new Date();
      const fechaNum = date.getDate();
      const mes_name = date.getMonth();
      const day = date.getDay() === 0 ? 6 : date.getDay() - 1;
      this.fecha = dias[day] + " " + this.zeroFill(fechaNum, 2) + " de " + meses[mes_name];
    },
    changePage(url) {
      this.closeMenu();
      if (!url || url === "#") {
        if (this.$swal) {
          this.$swal({
            icon: "info",
            title: "Próximamente",
            text: "Esta sección aún no está disponible.",
            confirmButtonColor: "#ff3128",
          });
        }
        return;
      }
      if (this.$route.path === url) return;
      this.$router.push(url);
    },
    handleClick() {
      this.closeMenu();
      const logout = () => {
        localStorage.removeItem("token");
        this.$router.push("/login");
      };
      if (!this.$swal) {
        logout();
        return;
      }
      this.$swal({
        title: "¿Cerrar sesión?",
        text: "Tendrás que volver a ingresar para continuar.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff3128",
        cancelButtonColor: "#938f8f",
        confirmButtonText: "Salir",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) logout();
      });
    },
    zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join("0") + number;
      }
      return number + "";
    },
    url(path) {
      this.$router.push(path);
    },
  },
  mounted() {
    this.basicInfo();
    window.addEventListener("keydown", this.onKeydown);
    window.addEventListener("resize", this.onResize);
    if (window.innerWidth <= 768) {
      $(".body__sidebar").addClass("open");
      $("#div_close").css("display", "none");
      $("#div_open").css("display", "flex");
    }
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown);
    window.removeEventListener("resize", this.onResize);
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.home nav.navbar.app-navbar {
  --nav-accent: #ff3128;
  --nav-accent-soft: #ffeeed;
  --nav-text: #2d2d2d;
  --nav-muted: #8a8686;
  --nav-border: #ececec;
  width: 100%;
  height: var(--navbar-height, 72px);
  min-height: var(--navbar-height, 72px);
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  padding: 0 20px 0 12px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid var(--nav-border);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8), 0 8px 24px rgba(15, 23, 42, 0.04);
  position: sticky;
  top: 0;
  z-index: 200;
  backdrop-filter: blur(10px);
}

.navbar__left {
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 8px;
}

.navbar__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 0;
  padding: 4px 8px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.18s ease;
}

.navbar__brand:hover {
  background: #fafafa;
}

.navbar__brand:focus-visible,
.nav-link:focus-visible,
.nav-icon-btn:focus-visible,
.hamburger:focus-visible {
  outline: 2px solid var(--nav-accent, #ff3128);
  outline-offset: 2px;
}

.navbar__left img,
.navbar__brand img {
  width: 108px;
  height: auto;
  display: block;
}

.navbar__center {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.desktop-menu {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0 8px;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: none;
}

.desktop-menu::-webkit-scrollbar {
  display: none;
}

.desktop-menu li {
  flex: 0 0 auto;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #555;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.nav-link i {
  font-size: 12px;
  color: #a3a3a3;
  width: 14px;
  text-align: center;
}

.nav-link:hover {
  background: #f6f6f6;
  color: var(--nav-text, #2d2d2d);
}

.nav-link:hover i {
  color: #666;
}

.nav-link.is-active {
  background: var(--nav-accent-soft, #ffeeed);
  color: var(--nav-accent, #ff3128);
  font-weight: 600;
}

.nav-link.is-active i {
  color: var(--nav-accent, #ff3128);
}

.navbar__right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 12px;
  border-left: 1px solid #f0f0f0;
}

.profile {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 100%;
}

.profile__user {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 4px 8px 4px 4px;
  border-radius: 12px;
}

.profile__avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--nav-accent-soft, #ffeeed);
  color: var(--nav-accent, #ff3128);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  border: 1px solid #ffd7d4;
}

.profile__detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  max-width: 160px;
}

.profile__name,
.profile__detail p {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--nav-text, #2d2d2d);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile__date,
.profile__detail span {
  color: var(--nav-muted, #8a8686);
  font-weight: 400;
  font-size: 11px;
  line-height: 1.3;
  white-space: nowrap;
}

.nav-icon-btn {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: var(--nav-accent, #ff3128);
  cursor: pointer;
  font-size: 15px;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.nav-icon-btn:hover {
  background: var(--nav-accent-soft, #ffeeed);
}

.nav-icon-btn.is-active {
  background: var(--nav-accent-soft, #ffeeed);
  border-color: #ffd0cd;
}

.nav-icon-btn--logout:hover {
  background: #fff1f0;
  color: #c4231c;
}

.hamburger {
  display: none;
  width: 40px;
  height: 40px;
  margin-left: auto;
  padding: 0;
  border: 1px solid #ececec;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
}

.hamburger span {
  display: block;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  background: #33495f;
  transition: transform 0.22s ease, opacity 0.22s ease;
}

.hamburger.is-open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.hamburger.is-open span:nth-child(2) {
  opacity: 0;
}

.hamburger.is-open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.nav-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.42);
  z-index: 1080;
  animation: navFade 0.2s ease;
}

.mobile-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: min(360px, 88vw);
  height: 100vh;
  height: 100dvh;
  background: #fff;
  z-index: 1081;
  display: flex;
  flex-direction: column;
  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.12);
  transform: translateX(104%);
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  pointer-events: none;
}

.mobile-drawer.is-open {
  transform: translateX(0);
  pointer-events: auto;
}

@media (min-width: 1101px) {
  .nav-overlay,
  .mobile-drawer {
    display: none !important;
  }
}

.mobile-drawer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 16px;
  border-bottom: 1px solid var(--nav-border, #ececec);
}

.mobile-drawer__head .profile__detail {
  max-width: 200px;
}

.mobile-drawer__nav {
  list-style: none;
  margin: 0;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.mobile-drawer__footer {
  padding: 12px;
  border-top: 1px solid var(--nav-border, #ececec);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-link--block {
  width: 100%;
  height: 46px;
  justify-content: flex-start;
  font-size: 14px;
  padding: 0 14px;
}

.nav-link--block i {
  font-size: 14px;
  width: 18px;
}

.nav-link--danger {
  color: var(--nav-accent, #ff3128);
}

.nav-link--danger i {
  color: var(--nav-accent, #ff3128);
}

@keyframes navFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (max-width: 1280px) {
  .nav-link span {
    max-width: 132px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .profile__detail {
    max-width: 120px;
  }
}

@media (max-width: 1100px) {
  .desktop-menu {
    display: none;
  }

  .hamburger {
    display: inline-flex;
  }

  .navbar__right {
    display: none;
  }

  .home nav.navbar.app-navbar {
    padding-right: 16px;
  }
}

@media (max-width: 480px) {
  .navbar__left img,
  .navbar__brand img {
    width: 92px;
  }
}
</style>
